import { TASKS_ORG_HEIRARCHY } from './org-heirarchy.tasks';
import { TEnhancedOrgHeirachyModel } from './org-heirarchy.types';

const log = (enhancedOrgTree: TEnhancedOrgHeirachyModel): TEnhancedOrgHeirachyModel => {
  //console.log('[org-Heirarchy-Model]', enhancedOrgTree);
  return enhancedOrgTree;
};
export const PIPELINE_ORG_HEIRARCHY = {
  toggleNode: (enhancedOrgTree: TEnhancedOrgHeirachyModel): TEnhancedOrgHeirachyModel => {
    return [TASKS_ORG_HEIRARCHY.collapseExpandNode, log].reduce((acc, fn) => fn(acc), enhancedOrgTree);
  },
  selectNodeInMultiSelection: (enhancedOrgTree: TEnhancedOrgHeirachyModel): TEnhancedOrgHeirachyModel => {
    return [
      TASKS_ORG_HEIRARCHY.selectAllChildNodes,
      TASKS_ORG_HEIRARCHY.setParentSelection,
      TASKS_ORG_HEIRARCHY.createPayload,
      log,
    ].reduce((acc, fn) => fn(acc), enhancedOrgTree);
  },
};
